import { COLORS } from '../../config/colors/colors';
import { styled } from 'goober';
import { PhoneInput } from 'react-international-phone';

export const StyledPhoneInput = styled(PhoneInput)`
    &:hover {
        .react-international-phone-input,
        .react-international-phone-country-selector-button {
            box-shadow: ${({ disabled }) => (disabled ? 'none' : `0 0 0 1px ${COLORS.neutral_50} inset`)};
        }
    }

    .react-international-phone-input,
    .react-international-phone-country-selector-button {
        height: 40px;
        border: none;
        box-shadow: ${({ disabled }) => (disabled ? 'none' : `0 0 0 1px ${COLORS.neutral_30} inset`)};
        transition: 0.15s ease-in;
    }

    .react-international-phone-input {
        font-family: inherit;
        font-size: 16px;
        line-height: 24px;
        font-weight: 400;
        color: ${({ disabled }) => (disabled ? COLORS.neutral_50 : COLORS.neutral_90)};
        flex-grow: 1;
        border-radius: 0 8px 8px 0;
    }

    .react-international-phone-country-selector-button {
        border-radius: 8px 0 0 8px;
    }

    .react-international-phone-flag-emoji {
        margin: 0 9px 0 13px;
    }

    .react-international-phone-country-selector-button__dropdown-arrow {
        width: 24px;
        height: 24px;
        margin-right: 8px;
        border: none;
        color: ${COLORS.neutral_50};
    }

    .react-international-phone-input--disabled,
    .react-international-phone-country-selector-button--disabled {
        background-color: ${COLORS.neutral_10} !important;
    }
`;
